<h4>{{element.description}}</h4>

<p>{{element.status_description}}</p>

<jsonforms-outlet *ngIf="hasParams"></jsonforms-outlet>

<button mat-button (click)="requestResult()" [disabled]="isLoading" i18n>REQUEST RESULT</button>

<app-card-error [error]="error"></app-card-error>
